import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DateService } from 'src/app/services/date.service';
import { VmsService } from 'src/app/services/vms.service';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-bulk-invite-home',
  templateUrl: './bulk-invite-home.component.html',
  styleUrls: ['./bulk-invite-home.component.scss']
})
export class BulkInviteHomeComponent implements OnInit,OnDestroy {
  openOptionDrawer: boolean = false;
  tempDate: any;
  formattedDate: string;
  today: string;
  response: any;
  constructor(private router: Router, private vmsSrv: VmsService,private dateSrv:DateService) {}
  private subscriptions = new Subscription();
  member: any = [];
  history: any = [];
  memberDetail: any;

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openDrawer(id, item) {
    $('#' + id).find('.drawer-container').toggle();

  }
  hidePopup(){
    $(document).on("click", function () {
      $(".drawer-container").hide();
  });
  }

  navigateToDetail(id) {
    localStorage.setItem('navigate', '1');
    this.router.navigate(['/vms/detail'],{queryParams:{id:id,type:'bulkInvite'}});
  }

  navigateToHistory(){
    localStorage.setItem('type', 'bulk-invite');
    this.router.navigate(['/vms/history']);
  }

  loadData() {
    const jsDate = new Date;
    console.log(jsDate)
    const data = {
      InvitationType: 'bulkInvite',
      ParkId:localStorage.getItem('parkId'),
    };
    this.subscriptions.add(this.vmsSrv.getInvitationList(data).subscribe((res) => {
      console.log(res);
      this.response=res
      this.today=this.dateSrv.convertDateToLocaleString(jsDate.getDate(),jsDate.getMonth(),jsDate.getFullYear())
      this.member=this.response.filter(res=>this.formatDate(res.mstart,'formatDate')>this.today)
      this.history=this.response.filter(res=>this.formatDate(res.mstart,'formatDate')<this.today)
    }))
  }

  reInvite(id){
    this.router.navigate(['/vms/bulk-invite/preview'],{queryParams:{id:id}});
  }

approvalRemainder(id){
  const data={
    InvitationId:id
  }
  this.subscriptions.add(this.vmsSrv.approvalRemainder(data).subscribe(res=>{
  }))
}

cancelInvite(id){
  this.subscriptions.add(this.vmsSrv.cancelInvitation(id).subscribe(res=>{
    if(res?.isValid){
      this.loadData();
    }
  }))
}

  formatDate(date,type){
  if(date==null) return
  this.tempDate=date.split('T')[0].split('-');
  this.formattedDate=this.dateSrv.convertDateToLocaleString(this.tempDate[2],this.tempDate[1],this.tempDate[0])
  if(type=='date') return this.tempDate[2]
  if(type=='month') return this.formattedDate.split(' ')[1]
  if(type=='format') return this.formattedDate.split(' ')[0]+' '+this.formattedDate.split(' ')[1]+','+this.formattedDate.split(' ')[2]
  if(type=='formatDate') return this.formattedDate
}


}
